const TENANT_ADMIN = 'Tenant_admin';

export const USER_ROLES = { TENANT_ADMIN };

export default { USER_ROLES };
